import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux"; // Redux 全局提供者
import { store } from "./store"; // 导入 Redux Store
import "./i18n"; // 导入多语言配置（无需挂载，只需执行初始化）
import "./index.scss"; // 导入全局样式
import App from "./App";

// 挂载根组件
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
